<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<mat-card>
    <mat-card-title>Utenti che hanno/non hanno effettuato l'accesso</mat-card-title>
    <mat-card-subtitle>Tasso utenti che non hanno effettuato l'accesso per sottogruppi. Sono stati considerati i pazienti che:<br>
      <ul>
        <li style="font-weight: bold;">Non hanno mai effettuato il login e sono stati registrati da più di 2 settimane</li>
      </ul>    
      L'analisi è stata effettuata per i seguenti sottogruppi: 
    </mat-card-subtitle>    <mat-card-content>
      <app-box-dashboard title="Globali" routerLink="/never-logged-global-section" image="inactive.png"></app-box-dashboard>
      <app-box-dashboard title="Categoria" route="/never-logged-category-section" image="options.png"></app-box-dashboard>
      <app-box-dashboard title="Patologia" route="/never-logged-pathology-section" image="diagnosi.png"></app-box-dashboard>
      <app-box-dashboard title="Sesso" route="/never-logged-sex-section" image="sesso.png"></app-box-dashboard>
      <app-box-dashboard title="Eta" route="/never-logged-age-section" image="eta.png"></app-box-dashboard>
      <app-box-dashboard title="Eta alla diagnosi" route="/never-logged-age-of-diagnosis-section" image="eta.png"></app-box-dashboard>
      <app-box-dashboard title="Durata malattia" route="/never-logged-pathology-duration-section" image="eta.png"></app-box-dashboard>
      <app-box-dashboard title="Terapia attiva" route="/never-logged-activetherapy-section" image="options.png"></app-box-dashboard>
      <app-box-dashboard title="Interventi" route="/never-logged-interventi-section" image="interventi.png"></app-box-dashboard>

  <div style="clear:both;"></div>
    </mat-card-content>
  </mat-card>
  <br>

  